module.exports = __webpack_public_path__ + "img/trei@3x.0f940344.png";